import React, { useRef } from 'react';
import { strictBreakpoints } from '../../styles/breakpoints';
import { LinkWithGAPromoClick } from '../link';
import { usePromoViewEvent } from '../../hooks';
import { Section } from '../section';
import { bannerImage, bannerLink } from './banner-section-styles';
import { BannerProps } from './banner-types';

type LinkBannerProps = {
  href: string;
  title: string;
} & BannerProps;

export const LinkBanner: React.FC<LinkBannerProps> = ({ banner, elementBlock, elementName, href, title }) => {
  const bannerRefs = useRef<HTMLAnchorElement[]>([]);

  const promotions = [{
    name: `${elementBlock} / ${elementName}`,
    creative: elementName,
    position: '0',
  }];

  usePromoViewEvent(bannerRefs, `${elementBlock} / ${elementName}`, promotions);

  return (
    <Section>
      <LinkWithGAPromoClick
        bannerRefs={bannerRefs}
        className={bannerLink}
        position={0}
        elementBlock={elementBlock}
        promotion={promotions[0]}
        href={href}
        title={title}
        target="_blank"
      >
        <picture>
          <source
            srcSet={banner.srcD}
            media={strictBreakpoints['--only-largeDesktop']}
          />
          <source
            srcSet={banner.srcD}
            media={strictBreakpoints['--only-desktop']}
          />
          <source
            srcSet={banner.srcT}
            media={strictBreakpoints['--only-tablet']}
          />

          <img
            alt={banner.alt}
            className={bannerImage}
            loading="lazy"
            src={banner.src}
          />
        </picture>
      </LinkWithGAPromoClick>
    </Section>
  );
}
